export const defaultConfig = {
    sanitization: {
        phoneNumbers: true,
        emails: true,
        creditCards: true,
        ssns: true,
        usernames: true,
        ipAddresses: true,
        dates: true,
        governmentIds: true,
        bankAccounts: true,
        cryptoWallets: true,
        macAddresses: true,
        deviceIds: true,
        cookies: true
    },
    ner: {
        persons: true,
        locations: true,
        organizations: true,
        misc: true
    }
};
